<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  watch: {
    $route(to, from) {
      this.$store.commit('update', { current_path: to.fullPath })
    }
  }
}
</script>
<style lang="scss">
.ui-select.has-label .ui-select__dropdown-button {
  top: 5px !important;
}
.ui-select:not(.is-multiple) .ui-select__display {
  min-width: 300px !important;
}
.ui-select.is-active:not(.is-disabled) .ui-select__display {
  min-width: 300px !important;
}
.ui-radio__inner-circle {
  height: 24px !important;
  width: 24px !important;
}
.hvr-shutter-out-horizontal.active {
  color: #fff;
  background: #c02323;
}
.top-bar.style4 .top-bar-user ul li:first-of-type:after {
  background-color: #fff;
}

/*tiny slider */
.tns-liveregion.tns-visually-hidden {
  display: none;
}
.tns-outer {
  button {
    display: none;
  }
}
</style>
